function repositionHeader() {
  $(".top-navigation-bar").remove();
  $("#header").remove();
  $(".menu-level-1 a").attr("target", "_blank");
}
